import { post } from "../index";

export const createTracking = (data) => {
  return post(`/tracking?user=${data[0]?.user}`, data);
};
